import React, { useEffect, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { ConsumablesMasterProps } from './consumables-master';
import help from './consumables-master.help';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import consumablesMasterColumns from '../../types/consumablesMasterDataType';
import notification from '@plasma/ui.feedback.notification';
import { setegid } from 'process';
import {  deleteDataFromApiWithBody } from '../../services/Deletes/deleteData';
import { apiUriConsumableDataHttp, apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useConsumablesMasterHook(props: ConsumablesMasterProps) {
  useResourceBundle(translations, undefined, '7c17759d-bb63-4f47-9065-99e283210195');
  useHelpBundle(help);

  const { t } = useTranslation();

  const [dataForColumns, setdataForColumns] = useState([]);
  const [dataForColumnsCopy, setdataForColumnsCopy] = useState([]);
  const [finaldataForColumns, setfinaldataForColumns] = useState([]);
  const [dataForEquipmentOptions, setdataForEquipmentOptions] = useState([]);
  const [billetOptions, setBilletOptions] = useState([]);
  const [columnNames, setcolumnNames] = useState(consumablesMasterColumns());
  const [dataToShowInModal, setdataToShowInModal] = useState({});
  const [modalVisible, setmodalVisible] = useState(false);
  const [modalTitle, setmodalTitle] = useState('');
  const [productName, setProductName] = useState<any>();
  const [productDescription, setProductDescription] = useState<any>();
  const [distinctProdName, setdistinctProdName] = useState([]);
  const [allProfilesDetailsListFromApi, setallProfilesDetailsListFromApi] = useState([]);
  const [descriptionByProdName, setdescriptionByProdName] = useState([]);
  const [listData, setlistData] = useState();
  const [ResetselectedIndex, setResetselectedIndex] = useState(false);
  const [isSelectedLoading, setisSelectedLoading] = useState(false);
  const [selectedIndex, setselectedIndex] = useState(-1);

  const [hiddenColumns] = useState(['remarks','quantityinstalled','quantityredressed','isactive','displayseq','lineseq']);

  useEffect (() => {
    loadData();
    loadOptions();
  },[]);

  const loadData = () => {
    fetchAllDataGet_byApiName("GetPlantConfigData", apiUriMasterDataHttp()).then((data) => {
      // Deep copy of data.consumableMaster
      const copiedDataForColumns = JSON.parse(JSON.stringify(data.consumableMaster));

      setdataForColumns(data.consumableMaster);
      setdataForEquipmentOptions(data.equipmentMaster);
      setdataForColumnsCopy(copiedDataForColumns);
    }).catch((error)=>{
      console.log("Failed to Fetch Consumables");
    });

  }

  const loadOptions = () => {
    fetchAllDataGet_byApiName("GetMasterInputMaterials", apiUriMasterDataHttp()).then((data) => {
      setBilletOptions(data);

    }).catch((error)=>{
      console.log("Failed to Fetch Areas");
    });

    //Get Product Details data to insert in the dropdown fields
  fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((response)=>{
    //set the response
   setallProfilesDetailsListFromApi(response);
   const allProductName =  response.map((item) => item.producttype);
   const distProdName = allProductName.filter((value, index, self) => self.indexOf(value) === index);
   //Added new option at 0th index
   distProdName.splice(0,0,"ALL SELECT");
   setdistinctProdName(distProdName);
  }).catch((error)=>{
    //console.log("error")
  });
  }

  //  console.log(allProfilesDetailsListFromApi);
  //  console.log(dataToShowInModal);

  useEffect(() => {

    useEffectFuntionONProductNameChange();

    if (productName === 'ALL SELECT'){
      const allProfileListArray = allProfilesDetailsListFromApi?.map(item => ({
        "producttype": item.producttype,
        "productdescription": item.productdescription
    }));

    setdataToShowInModal((prevData) => {
      return{
        ...prevData,
        productprofiles: allProfileListArray
      }
    })
    }

  },[productName]);


  useEffect(()=>{

    useEffectFuntionONProductNameChange();

  },[dataToShowInModal]);

  const useEffectFuntionONProductNameChange = () =>{
    const ProfilesfilteredByProductName_array = allProfilesDetailsListFromApi?.filter(item => item.producttype === productName)?.map(item => item.productdescription);
    const existingProfileDescriptions = dataToShowInModal.productprofiles?.map((item) =>{
      return item.productdescription;
    })
    const filteredByDescriptions = ProfilesfilteredByProductName_array?.filter((item) => !existingProfileDescriptions?.includes(item));
    //console.log("ProductDecriptions Filtered");
    setdescriptionByProdName(filteredByDescriptions);
  }

  useEffect(()=> {
    const newDataForColumns = dataForColumns?.map((eachData) => {
      const newProductprofielArray = eachData?.productprofiles?.map((eachProfile) =>{
        const reFormattedProfile = eachProfile.producttype + " " + eachProfile.productdescription;
        return reFormattedProfile
      });
      eachData.productprofiles = newProductprofielArray;
      return eachData;
    });

    setfinaldataForColumns(newDataForColumns);

  },[dataForColumns]);

  useEffect (()=> {
    const allColumnsWithOptions =
    columnNames?.map((item)=> {

      if(item.accessor === 'billetid'){
        item.options = billetOptions.map((bOpt) => {
          return({
            value: bOpt.materialcode,
            display: bOpt.materialname + " - " + bOpt.materialdescription
          })
        })
      }

      return item;
    })

    //console.log(allColumnsWithOptions);
    setcolumnNames(allColumnsWithOptions);

  },[dataForEquipmentOptions]);


  const handleSaveAndDeleteFromTable = async (data, returnType, index) =>{

    //const maxDisplaySeq = Math.max(...dataForColumns.map(item => item.displayseq));

    if(data?.displayseq === ''){
      data.displayseq = (index + 1) ;
      }
    if(data?.lineseq === '' || data?.lineseq === null){
      data.lineseq = 0;
      }
    if(data?.lifetime === ''){
      data.lifetime = 0;
      }
    if(data?.quantityinstalled === ''){
      data.quantityinstalled = 0;
      }
    if(data?.quantityredressed === ''){
      data.quantityredressed = 0;
      }

    data.displayseq = parseFloat(data.displayseq);
    data.lineseq = parseFloat(data.lineseq);
    data.lifetime = parseFloat(data.lifetime);
    data.quantityinstalled = parseFloat(data.quantityinstalled);
    data.quantityredressed = parseFloat(data.quantityredressed);
    data.productprofiles = [];


    if (data?.isactive === '' ) {
      data.isactive = false ;
      }

    if (data?.consumablename === null ) {
      data.consumablename = '' ;
      }
    if (data?.remarks === null ) {
      data.remarks = '' ;
      }

    //console.log(data, returnType, index);

    if (returnType === 'delete'){
      //console.log("DELETE")
      const selectedRowData = dataForColumnsCopy[index];

      if(selectedRowData?.displayseq === ''){
        selectedRowData.displayseq = (index + 1) ;
        }
      if(selectedRowData?.lineseq === '' || selectedRowData?.lineseq === null){
        selectedRowData.lineseq = 0;
        }
      if(selectedRowData?.lifetime === ''){
        selectedRowData.lifetime = 0;
        }
      if(selectedRowData?.quantityinstalled === ''){
        selectedRowData.quantityinstalled = 0;
        }
      if(selectedRowData?.quantityredressed === ''){
        selectedRowData.quantityredressed = 0;
        }

      selectedRowData.displayseq = parseFloat(selectedRowData.displayseq);
      selectedRowData.lineseq = parseFloat(selectedRowData.lineseq);
      selectedRowData.lifetime = parseFloat(selectedRowData.lifetime);
      selectedRowData.quantityinstalled = parseFloat(selectedRowData.quantityinstalled);
      selectedRowData.quantityredressed = parseFloat(selectedRowData.quantityredressed);

      if (selectedRowData?.isactive === '' ) {
        selectedRowData.isactive = false ;
        }

      if (selectedRowData?.consumablename === null ) {
        selectedRowData.consumablename = '' ;
        }
      if (selectedRowData?.remarks === null ) {
        selectedRowData.remarks = '' ;
        }

        deleteDataFromApiWithBody('DeleteConsumables', selectedRowData, apiUriConsumableDataHttp()).then((response) => {
        //console.log(response);
        if(response){
          fetchAllDataGet_byApiName("GetPlantConfigData", apiUriMasterDataHttp()).then((dataFromApi) => {
            const copiedDataForColumns = JSON.parse(JSON.stringify(dataFromApi.consumableMaster));
            setdataForColumns(dataFromApi.consumableMaster);
            setdataForColumnsCopy(copiedDataForColumns);
            notification.success('Removed !', 'Data Deleted Permanently', undefined, 'medium', 3)
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }
      }).catch((error) => {
        console.log(error);
      });
    }

    else if(returnType.includes('insert')){

        if(data.consumabledescription !== '' || data.consumablecodeext !== '' || data.billetid !== ''){
          //console.log(data);
          setdataToShowInModal(data);
          setmodalVisible(!modalVisible);
          setselectedIndex(index);
          setisSelectedLoading(true);
        }
        else{
          fetchAllDataGet_byApiName("GetPlantConfigData", apiUriMasterDataHttp()).then((dataFromApi) => {
            const copiedDataForColumns = JSON.parse(JSON.stringify(dataFromApi.consumableMaster));
            setdataForColumns(dataFromApi.consumableMaster);
            setdataForColumnsCopy(copiedDataForColumns);
            notification.error('Warning !', 'You Didn\'t Enter Any Data Before Save Click', undefined, 'medium', 3)
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }

    }
    else{
      //console.log(data, index);
      handleSelectedRowInEditMode(index, data);
      //setselectedIndex(index);
    }
  };

  const handleSelectedRowInEditMode = (rowIndex, rowData) => {
    let SelectedRowFromDataFromColumns  = dataForColumnsCopy[rowIndex];
    //console.log(SelectedRowFromDataFromColumns);
    const constRowData = rowData;
    constRowData.productprofiles = rowData.productprofiles.concat(SelectedRowFromDataFromColumns.productprofiles);
    //console.log(constRowData);
    setdataToShowInModal(constRowData);
    setmodalTitle(SelectedRowFromDataFromColumns.consumablecodeext);
    setmodalVisible(!modalVisible);
    const firstSelection = SelectedRowFromDataFromColumns.productprofiles[0]?.producttype;
    setProductName(firstSelection);
  };

  const handleSelectedRow = (rowIndex) => {
    setResetselectedIndex(false);
    let SelectedRowFromDataFromColumns  = dataForColumnsCopy[rowIndex];
    setdataToShowInModal(SelectedRowFromDataFromColumns);
    //console.log('Selected code: ',SelectedRowFromDataFromColumns.consumablecodeext);
    setmodalTitle(SelectedRowFromDataFromColumns.consumablecodeext);
    setmodalVisible(!modalVisible);
    const firstSelection = SelectedRowFromDataFromColumns.productprofiles[0]?.producttype;
    setProductName(firstSelection);
    setisSelectedLoading(true);

    //console.log(dataForColumnsCopy[rowIndex]);
  };

  const handleProductNameChange = (value: string)=> {
    setProductName(value);
    setProductDescription(null);
    dataToShowInModal.productprofiles
    //setMessage('');
  };

  const handleProductDescriptionChange = (value: string)=> {
    setProductDescription(value);
    // setMessage('');
  };

  const handleAddProduct = () => {
    const newProfile = { producttype: productName, productdescription: productDescription };
    const newProductProfilesList = [...dataToShowInModal.productprofiles, newProfile];
    const newDataToShowInModal = { ...dataToShowInModal, productprofiles: newProductProfilesList };
    console.log(newDataToShowInModal);
    setdataToShowInModal(newDataToShowInModal);
    setProductDescription(null);

};

  const removeItemFromAddedList = (itemToRemove)=> {
    //console.log(itemToRemove);

    const updatedProductProfiles = dataToShowInModal.productprofiles.filter(profile => {
      return profile.producttype !== itemToRemove.producttype || profile.productdescription !== itemToRemove.productdescription;
    });

  // Update the data with the modified productprofiles
    const updatedData = { ...dataToShowInModal, productprofiles: updatedProductProfiles };

    setdataToShowInModal(updatedData);

  };

  const HandleSaveFromModal = () =>{

    if(dataToShowInModal.displayseq === ''){
      dataToShowInModal.displayseq = (index + 1) ;
      }
    if(dataToShowInModal.lineseq === '' || dataToShowInModal.lineseq === null){
      dataToShowInModal.lineseq = 0;
      }
    if(dataToShowInModal.lifetime === ''){
      dataToShowInModal.lifetime = 0;
      }
    if(dataToShowInModal.quantityinstalled === ''){
      dataToShowInModal.quantityinstalled = 0;
      }
    if(dataToShowInModal.quantityredressed === ''){
      dataToShowInModal.quantityredressed = 0;
      }

    dataToShowInModal.displayseq = parseFloat(dataToShowInModal.displayseq);
    dataToShowInModal.lineseq = parseFloat(dataToShowInModal.lineseq);
    dataToShowInModal.lifetime = parseFloat(dataToShowInModal.lifetime);
    dataToShowInModal.quantityinstalled = parseFloat(dataToShowInModal.quantityinstalled);
    dataToShowInModal.quantityredressed = parseFloat(dataToShowInModal.quantityredressed);


    if (dataToShowInModal.isactive === '' ) {
      dataToShowInModal.isactive = false ;
      }

    if (dataToShowInModal.consumablename === null ) {
      dataToShowInModal.consumablename = '' ;
      }
    if (dataToShowInModal.remarks === null ) {
      dataToShowInModal.remarks = '' ;
      }

    //console.log(dataToShowInModal);

    sendAllDataPost_byApiNameAndData('AddConsumables', dataToShowInModal, apiUriConsumableDataHttp())
      .then((response) => {
        //console.log(response);
        if(response){
          notification.success('Success !', 'Data Saved Successfully', undefined, 'medium', 3);
          loadData();
          loadOptions();
          HandleModalCancel();
        }
      }).catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });

};


  const HandleModalCancel = () =>{
    setProductName(null);
    setResetselectedIndex(true);
    setmodalTitle('');
    setmodalVisible(false);
  };

  const handleClearAll = () => {
    setdataToShowInModal((prevData) => {
      return {
        ...prevData,
        productprofiles: [] // Assigning directly to the property
      }
    });

    setProductName(null);
    setProductDescription(null);
  };

  return {
    t,
    dataForColumns,
    columnNames,
    hiddenColumns,
    modalVisible,
    dataToShowInModal,
    finaldataForColumns,
    productName,
    productDescription,
    distinctProdName,
    descriptionByProdName,
    isSelectedLoading,
    selectedIndex,
    modalTitle,
    handleSaveAndDeleteFromTable,
    handleSelectedRow,
    HandleSaveFromModal,
    HandleModalCancel,
    handleProductNameChange,
    handleProductDescriptionChange,
    handleAddProduct,
    removeItemFromAddedList,
    handleClearAll,
    ResetselectedIndex
  };
}

export default useConsumablesMasterHook;
